'use client';

import { useState } from 'react';
import { cn } from '@bedrock/ui/utils';
import dynamic from 'next/dynamic';
import { type ContentfulPDFType } from 'lib/contentful/types';
import { LazyWrap } from 'ui/common/lazy-wrap';
import './pdf-viewer.css';

const Document = dynamic(
  () =>
    import('react-pdf').then((m) => {
      m.pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
      ).toString();
      return m.Document;
    }),
  { ssr: false },
);
const Page = dynamic(() => import('react-pdf').then((m) => m.Page), { ssr: false });

type PDFViewerProps = { pdf: ContentfulPDFType; className?: string };

function PDFViewer({ pdf, className }: Readonly<PDFViewerProps>) {
  const [numPages, setNumPages] = useState<number>();
  return (
    <LazyWrap
      className={cn(
        'relative z-10 m-auto flex w-full justify-center px-4 md:max-w-[768px] lg:max-w-[1024px]',
        className,
      )}
    >
      <Document
        file={pdf.pdf.file.url}
        onLoadSuccess={({ numPages: n }) => {
          setNumPages(n);
        }}
      >
        {Array.from({ length: numPages ?? 0 }, (_, i) => (
          <Page key={i} pageNumber={i + 1} renderAnnotationLayer={false} renderTextLayer={false} />
        ))}
      </Document>
    </LazyWrap>
  );
}

export default PDFViewer;
